module.exports = __webpack_public_path__ + "static/media/airblitz-4.d200630e.jpg";